

import {
  FETCH_HOLIDAYS_REQUEST,
  FETCH_HOLIDAYS_SUCCESS,
  FETCH_HOLIDAYS_FAILURE,
  CREATE_HOLIDAY_REQUEST,
  CREATE_HOLIDAY_SUCCESS,
  CREATE_HOLIDAY_FAILURE,
  UPDATE_HOLIDAY_REQUEST,
  UPDATE_HOLIDAY_SUCCESS,
  UPDATE_HOLIDAY_FAILURE,
} from "../actions/holidayActions";

const initialState = {
  holidays: [],
  loading: false,
  error: null,
  creating: false,
  updating: false,
};

const holidayReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HOLIDAYS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_HOLIDAYS_SUCCESS:
      return { ...state, loading: false, holidays: action.payload };

    case FETCH_HOLIDAYS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_HOLIDAY_REQUEST:
      return { ...state, creating: true, error: null };

    case CREATE_HOLIDAY_SUCCESS:
      return { ...state, creating: false };

    case CREATE_HOLIDAY_FAILURE:
      return { ...state, creating: false, error: action.payload };

    case UPDATE_HOLIDAY_REQUEST:
      return { ...state, updating: true, error: null };

    case UPDATE_HOLIDAY_SUCCESS:
      return { ...state, updating: false };

    case UPDATE_HOLIDAY_FAILURE:
      return { ...state, updating: false, error: action.payload };

    default:
      return state;
  }
};

export default holidayReducer;
